module.exports = __webpack_public_path__ + "img/terms.d74b2c3c.jpg";